<template>
    <div>
        <font-awesome-icon icon="far fa-location" />
        {{ vehicleLocation }}
    </div>
</template>

<script>
export default {
    name: "Location",
    props: {
        vehicleLocation: {
            type: String
        }
    },
}
</script>
